import styled from "@emotion/styled";
import { Button } from "@mui/material";

const storeSettingsFieldMaxWidth = 520;

export const StoreSettingsPageHeader = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	padding: "20px 32px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	h1: {
		...theme.project.typography.heading.h4,
		color: theme.project.colors.fontColors.main,
		margin: 0
	},
	[theme.breakpoints.down("md")]: {
		alignItems: "flex-start",
		flexDirection: "column",
		gap: theme.project.layout.gap.large
	}
}));

export const StoreSettingsContainer = styled.form(({ theme }) => ({
	padding: 20,
	margin: "12px",
	border: theme.project.borders.presets.outline,
	borderWidth: "1px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	[theme.breakpoints.down("lg")]: {
		padding: 16
	}
}));

export const StoreSettingsSection = styled.section(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: 16,
	"& + &": {
		borderTop: theme.project.borders.presets.outline,
		borderWidth: "1px 0 0 0",
		marginTop: 24,
		paddingTop: 24
	}
}));

export const StoreSettingsSectionTitle = styled.h2(({ theme }) => ({
	...theme.project.typography.subtitle,
	color: theme.project.colors.fontColors.secondary,
	fontWeight: 400,
	letterSpacing: "1px",
	fontSize: "16px",
	margin: 0
}));

export const StoreSettingsRequiredFieldText = styled.p(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	margin: 0
}));

export const StoreSettingsFieldsGrid = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "minmax(0, 1fr)",
	gap: 16,
	maxWidth: storeSettingsFieldMaxWidth,
	width: "100%"
}));

export const FullWidthField = styled.div({
	width: "100%"
});

export const FieldStack = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 8
});

export const NotificationRow = styled.div<{ $hasRemoveButton: boolean }>(({ theme, $hasRemoveButton }) => ({
	display: "grid",
	gridTemplateColumns: $hasRemoveButton
		? `minmax(0, ${storeSettingsFieldMaxWidth}px) auto`
		: `minmax(0, ${storeSettingsFieldMaxWidth}px)`,
	gap: $hasRemoveButton ? 12 : 0,
	alignItems: "center",
	width: "fit-content",
	maxWidth: "100%",
	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "1fr",
		width: "100%"
	}
}));

export const NotificationFieldGroup = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 4
});

export const StoreSettingsLeadEmailList = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 8,
	width: "100%"
});

export const InlineRemoveButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	minWidth: 0,
	padding: 0,
	justifyContent: "flex-start",
	[theme.breakpoints.down("sm")]: {
		paddingTop: 0
	}
}));

export const SectionHelperText = styled.p(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	margin: 0,
	maxWidth: storeSettingsFieldMaxWidth,
	width: "100%"
}));

export const StoreSettingsLeadActionsRow = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "minmax(0, 1fr) auto",
	alignItems: "center",
	gap: 16,
	width: "100%",
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr"
	}
}));

export const StoreSettingsAddEmailButton = styled(Button)(({ theme }) => ({
	width: "fit-content",
	minWidth: 0,
	paddingLeft: 0,
	alignSelf: "center",
	[theme.breakpoints.down("md")]: {
		justifyContent: "flex-start"
	}
}));

export const StoreSettingsTopActions = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-end",
	alignItems: "center",
	gap: 16,
	[theme.breakpoints.down("md")]: {
		flexDirection: "column-reverse"
	}
}));

export const StoreSettingsInfoBanner = styled.div({
	width: "100%"
});

export const StoreSettingsDealerLocatorList = styled.ul(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main,
	display: "flex",
	flexDirection: "column",
	gap: 8,
	margin: 0,
	paddingLeft: 24
}));

export const StoreSettingsDealerLocatorListItem = styled.li(({ theme }) => ({
	...theme.project.typography.body.body2,
	lineHeight: 1.5,
	wordBreak: "break-word"
}));

export const StoreSettingsDealerLocatorListLabel = styled.span({
	fontWeight: 400
});

export const StoreSettingsButton = styled(Button)(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		width: "100%"
	}
}));

export const StoreSettingsErrorBoxWrapper = styled.div(({ theme }) => ({
	width: "100%",
	height: "100vh",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.main
}));

export const StoreSettingsLoadingWrapper = styled.div(({ theme }) => ({
	padding: 12,
	backgroundColor: theme.project.colors.backgroundColors.main
}));
